<h2 mat-dialog-title>Retry Purchase</h2>
<mat-dialog-content class="dialog">
  <p>
    Are you sure you want to retry this purchase for
    <strong>{{ purchase.total | price: usd : null : true : false }}</strong>
    ?
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="retryPurchase()" [disabled]="loading">Retry</button>
</mat-dialog-actions>
